/**
 * @fileoverview Represent a caller-owned Boolean choice using the shared form event convention. This control owns switch interaction; saving a setting or enabling a business capability belongs to the consuming workflow.
 */

import React from 'react'
import './AppToggle.css'

/**
 * onChange receives {value: boolean}. checked remains parent-controlled. A rendered switch or its local change event does not establish that a server setting was accepted.
 */
function AppToggle({ checked, onChange, disabled, ariaLabel, id, inputId, className, ...props }) {
    const handleChange =

    (e) => {
        if (disabled) return
        onChange({ value: e.target.checked })
    }

    return (
        <label className={`app-toggle${disabled ? ' disabled' : ''}`}>
            <input
                type="checkbox"
                id={inputId || id}
                checked={!!checked}
                onChange={handleChange}
                disabled={disabled}
                aria-label={ariaLabel || props['aria-label']}
            />
            <span className="app-toggle-track" />
            <span className="app-toggle-thumb" />
        </label>
    )
}

export default AppToggle

export { AppToggle as InputSwitch };
